import MembershipProductEvaluationHandler from './MembershipProductEvaluationHandler';
export const membershipProductEvaluationHandler = MembershipProductEvaluationHandler();